module.exports = __webpack_public_path__ + "img/batman.92e1d689.jpeg";